<template>
  <div class="flex justify-center items-center gap-4 md:gap-6 md:pb-5 lg:pb-10">
    <slot />
  </div>
</template>
